export default function isValueRestricted(count, characterRestriction) {
    let maxValue = characterRestriction;
    if (typeof characterRestriction === 'object') {
        maxValue = characterRestriction.max;
    }
    return count > maxValue;
}
